(() => {
  const initCarousels = (root = document) => {
    root.querySelectorAll('[data-guide-carousel]').forEach((carousel) => {
      if (carousel.dataset.guideReady === 'true') return;
      carousel.dataset.guideReady = 'true';

      const track = carousel.querySelector('[data-guide-track]');
      const prev = carousel.querySelector('[data-guide-prev]');
      const next = carousel.querySelector('[data-guide-next]');
      const cards = [...track.querySelectorAll('.bs-guide__product')];
      const media = cards[0]?.querySelector('.bs-guide__product-media');

      const gap = () => parseFloat(getComputedStyle(track).columnGap) || 0;
      const cardStep = () => (cards[0]?.getBoundingClientRect().width || 0) + gap();
      const visibleCount = () => Math.max(1, Math.round((track.clientWidth + gap()) / cardStep()));

      const update = () => {
        if (media) {
          carousel.style.setProperty('--bs-guide-media-half', `${media.getBoundingClientRect().height / 2}px`);
        }
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };

      const move = (direction) => {
        const step = cardStep();
        if (!step) return;
        const pageSize = visibleCount();
        const currentPage = Math.round(track.scrollLeft / (step * pageSize));
        const lastIndex = Math.max(0, cards.length - pageSize);
        const targetIndex = Math.min(lastIndex, Math.max(0, (currentPage + direction) * pageSize));
        track.scrollTo({
          left: targetIndex * step,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };

      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
  };

  initCarousels();
  document.addEventListener('shopify:section:load', (event) => initCarousels(event.target));
})();
